import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const ThemeContext = createContext(null);

// Chave nova de proposito. A anterior ("theme") gravava tambem o valor RESOLVIDO a partir
// do prefers-color-scheme, sem o usuario ter escolhido nada — entao quase todo mundo tem
// "light" gravado por acidente. Reaproveitar aquela chave faria a base inteira continuar
// no tema claro. Aqui so gravamos quando a escolha e explicita.
const THEME_STORAGE_KEY = "flamex-theme";
const DEFAULT_THEME = "dark";

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    return storedTheme === "dark" || storedTheme === "light" ? storedTheme : DEFAULT_THEME;
  });

  useEffect(() => {
    // Troca de tema sem transicoes: dezenas de elementos com `transition-colors`/`transition-all`
    // animavam a cor ao mesmo tempo e a pagina inteira engasgava. Desliga tudo, aplica a classe,
    // forca o navegador a calcular o estilo novo e religa no tick seguinte.
    const disableTransitions = document.createElement("style");
    disableTransitions.appendChild(
      document.createTextNode("*,*::before,*::after{transition:none!important}")
    );
    document.head.appendChild(disableTransitions);

    document.documentElement.classList.toggle("dark", theme === "dark");

    window.getComputedStyle(document.body).getPropertyValue("color");
    const timeoutId = window.setTimeout(() => disableTransitions.remove(), 1);

    return () => {
      window.clearTimeout(timeoutId);
      disableTransitions.remove();
    };
  }, [theme]);

  const value = useMemo(() => {
    const setTheme = (next) => {
      setThemeState((prev) => {
        const resolved = typeof next === "function" ? next(prev) : next;
        localStorage.setItem(THEME_STORAGE_KEY, resolved);
        return resolved;
      });
    };

    return {
      theme,
      isDark: theme === "dark",
      setTheme,
      toggleTheme: () => setTheme((prev) => (prev === "dark" ? "light" : "dark")),
    };
  }, [theme]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within ThemeProvider");
  }
  return context;
}
